export const postMessage = (type, data = {}) =>
  window.parent.postMessage(
    {
      type,
      ...(data || {})
    },
    window.location.origin
  )
